module.exports = __webpack_public_path__ + "img/input-symbols.d0ab9421.png";